import { Component, OnInit } from '@angular/core';
import { CoreTranslateService, UtilitysService } from './services/utilitys/utilitys.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private utility: UtilitysService,
    private translate: CoreTranslateService
  ){
    
  }

  async ngOnInit() {
    let lang = localStorage.getItem("language") || 'th' ;
    // window.localStorage.setItem('language', lang);
    await this.translate.use(lang);
  }
}
